import { Button } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function AmendsEditActionButton({ onEdit, canEdit = true }) {
    return (
        <Button
            aria-label="Edit author notes"
            size="small"
            color="primary"
            onClick={onEdit}
            disabled={!canEdit}
            data-cy="amends-edit-button"
            startIcon={<Iconify icon="mdi:pencil" width={18} />}
        >
            Edit
        </Button>
    )
}
